define([
	"dojo/_base/declare",
	"dojo/request/xhr",
	"csi",
	"csi/action/Controller",
	"csi/locale",
	"csi/state",
	"csi/utility/stringUtility",
	"csi/view/PrintService"
], function(declare, xhr, csi, Controller, locale, state, {stringSubstitute}, PrintService) {

	var _printTemplate = null;

	// Dynamically load 'printwindow.html'.
	// We cannot load it statically using 'dojo/text!' because
	// 'printwindow.html' is processed by Webpack after PrintController.js is processed
	function resolvePrintTemplate() {
		if (_printTemplate) {
			return Promise.resolve(_printTemplate);
		} else {
			return xhr(csi.url("printwindow.html"), {
				handleAs: "text"
			}).then(function(res) {
				_printTemplate = res;
				return res;
			}, function(err) {
				console.error("Cannot find printwindow.html");
			});
		}
	}

	return declare(Controller, {
		bPrintPreview: false,

		constructor: function(/*Object*/params) {
			// summary: on data sheets refresh button could belong to nested view even though the toolbar appears
			// above root view. In this case, change the refresh widget to the root view.
			// FIX - not sure this is ever used anymore
			var view = this.widget.getToolbarContainerView();
			if (view && !view.toolbarNode) {
				this.widget = view;
			}
		},

		process: function() {
			var self = this;
			var title = PrintService.getPrintTitle(this.widget);

			this.setProgress();

			// set state indicating client is in process of ad-hoc printing
			state.set("printAdHoc", true);

			this.when(PrintService.printCurrentView(this.widget, false, !this.bPrintPreview), function(result) {
				if (self.bPrintPreview) {
					var win = csi.browserWindow("", "C8Print");
					if (win) {
						resolvePrintTemplate().then(function(printTemplate) {
							var printScale = Math.floor((state.get("printScale") || 1) * 100) + "%";
							var s = stringSubstitute(printTemplate, {
								content: result.content,
								mergedCss: csi.urlForGenerated("Site_Merged", true),
								orientation: locale.resource("PrintOrientation" + result.orientation),
								paperSize: locale.resource("PaperSize:" + result.paper),
								printScale,
								printAutoScale: state.get("printAutoScale") ? "On" : "Off",
								title
							});

							win.document.write(s);
							win.document.close();
							win.focus();
							self.postProcess(true);
						});
					} else {
						self.postProcess(false);
					}
				} else {
					window.print();
					self.postProcess(true);
				}
			});
		}
	});
});
